/**
 * Returns the panel count for a particular tracking event
 * 
 * @param {*} trackingEvent - Tracking event for which the panel count has to be returned.
 * @param {*} dataLayer     - current window.dataLayer instance
 */
export default function getPanelCount(trackingEvent, dataLayer = [...window.dataLayer]) {
  const item = dataLayer.reverse().find(item => item.event == trackingEvent);
  return item && item.panel_count ? item.panel_count + 1 : 1;
}
